import {NgModule} from "@angular/core";
import {AdministrasjonSpørreskjemaerAvhengigheter} from "web-ng2/moduler/administrasjon/komponenter/administrasjon-spørreskjemaer/administrasjon-spørreskjemaer";
import {SpørreskjemaRedigerAvhengigheter} from "web-ng2/moduler/administrasjon/komponenter/spørreskjema-rediger/spørreskjema-rediger";
import {VelgAvtalerAvhengigheter} from "web-ng2/moduler/administrasjon/komponenter/velg-avtaler/velg-avtaler";

@NgModule({
    providers: [
        AdministrasjonSpørreskjemaerAvhengigheter,
        SpørreskjemaRedigerAvhengigheter,
        VelgAvtalerAvhengigheter
    ]
})
export class AdministrasjonModul {}
